module.exports = __webpack_public_path__ + "img/11.eed84ee6.png";